import React from "react";
import InfoIcon from "@/assets/img/symbolic/fa-info.svg?react";

interface ToggleSwitchProps
{
    checked: boolean;
    onChange: (checked: boolean) => void;
    disabled?: boolean;
    label?: string;
    toolTip?: string;
}

const ToggleSwitch: React.FC<ToggleSwitchProps> = ({
    checked,
    onChange,
    disabled = false,
    label,
    toolTip,
}) =>
{
    return (
        <label
            className={Wind.style({
                display: "inline-flex",
                alignItems: "items-center",
                cursor: disabled ? "cursor-not-allowed" : "cursor-pointer",
            }).class}
        >
            <input
                type="checkbox"
                checked={checked}
                onChange={e => void onChange(e.target.checked)}
                disabled={disabled}
                className={Wind.style({
                    display: "hidden",
                }).class}
            />
            <span
                className={Wind.style({
                    width: "w-10",
                    height: "h-5",
                    borderRadius: "rounded-full",
                    display: "inline-block",
                    position: "relative",
                    transition: "transition-colors ease-in-out",
                    transitionDuration: "duration-200",
                    backgroundColor: checked ? "bg-emerald-400" : "bg-gray-300",
                }).class}
            >
                <span
                    className={Wind.style({
                        position: "absolute",
                        top: "top-0.5",
                        width: "w-4",
                        height: "h-4",
                        backgroundColor: "bg-white",
                        borderRadius: "rounded-full",
                        transition: "transition-all ease-out",
                        transitionDuration: "duration-200",
                        boxShadow: "shadow",
                        left: checked ? "left-5" : "left-0.5",
                    }).class}
                />
            </span>
            {label && (
                <span
                    className={Wind.style({
                        marginLeft: "ml-2",
                        userSelect: "select-none",
                        color: "text-white",
                    }).class}
                >
                    {label}
                </span>
            )}
            {toolTip && (
                <span
                    className={Wind.style({
                        position: "relative",
                        display: "inline-block",
                        marginLeft: "ml-2",
                    }).class + " group"}
                >
                    <span
                        className={Wind.style({
                            visibility: "invisible",
                            opacity: "opacity-0",
                            width: "w-max",
                            backgroundColor: "bg-gray-800",
                            color: "text-white",
                            textAlign: "text-center",
                            borderRadius: "rounded",
                            paddingX: "px-2",
                            paddingY: "py-1",
                            position: "absolute",
                            zIndex: "z-10",
                            bottom: "bottom-0",
                            left: "left-1/2",
                            transformTranslateX: "-translate-x-1/2",
                            fontSize: "text-xs",
                            transition: "transition-opacity ease-in-out",
                            transitionDuration: "duration-200",
                            pointerEvents: "pointer-events-none",
                            whitespace: "whitespace-nowrap",
                        }).class + " group-hover:visible group-hover:opacity-100"}
                        role="tooltip"
                    >
                        {toolTip}
                    </span>
                    <span
                        className={Wind.style({
                            color: "text-poppy-yellow",
                            fontSize: "text-sm",
                            cursor: "cursor-help",
                        }).class}
                        tabIndex={0}
                        aria-label={toolTip}
                    >
                        <InfoIcon
                            className={Wind.style({
                                width: "w-4",
                                height: "h-4",
                                color: "text-poppy-yellow"
                            }).class}
                        />
                    </span>
                </span>
            )}
        </label>
    );
};

export default ToggleSwitch;
